const DEFAULT_PRODUCTION_BASE_URL = 'https://openai.talkvia.com.br';
const DEFAULT_NON_PRODUCTION_BASE_URL = 'https://sandbox-openai.talkvia.com.br';
export const DEFAULT_PRODUCTION_AI_WEBHOOK_URL =
  'http://94.72.183.130:3008/chat/stream';

export const TALKVIA_OPENAI_BASE_URL =
  import.meta.env.VITE_TALKVIA_OPENAI_BASE_URL ||
  (import.meta.env.PROD
    ? DEFAULT_PRODUCTION_BASE_URL
    : DEFAULT_NON_PRODUCTION_BASE_URL);

export const TALKVIA_AI_WEBHOOK_URL =
  import.meta.env.VITE_TALKVIA_AI_WEBHOOK_URL ||
  (import.meta.env.PROD
    ? DEFAULT_PRODUCTION_AI_WEBHOOK_URL
    : `${TALKVIA_OPENAI_BASE_URL}/chat/stream`);
export const TALKVIA_BANKING_VALIDATION_URL = `${TALKVIA_OPENAI_BASE_URL}/banking/validate`;
